import React, { Component } from "react";
import Head from "../components/Head";
import { auth } from "../config/fire";
import { Input, message } from 'antd';
import { updateprof, updatephoto } from "../helpers/auth";
import Loader from "../components/Loader";
import { DashboardContainer, DashMainWrapper, DashProfContainer, DashButtons, DashFormDiv,HomeConnectButton } from './styles';

export default class UserProfile extends Component {

    constructor(props) {
        super(props);
        document.title = 'Dashboard';
        this.state = {
            uname: auth().currentUser.displayName,
            loading: true,
            editEnable: false,
            props: props,
            
        }
        this.handleChange = this.handleChange.bind(this);
        this.updateprofile = this.updateprofile.bind(this);
        this.updatepropic = this.updatepropic.bind(this);
    }

    componentDidMount() {
        if(!auth().currentUser.displayName){
            message.error({
                content: 'Please Provide Your Name',
                duration: [3]
            })
        } 
        this.setState({
            loading: false,
        })
    }

    async updateprofile(event) {
        event.preventDefault();
        
        if(this.state.uname === auth().currentUser.displayName){
            message.error({
                content: 'You Didnt Changed The Name',
                duration: [2],
            });
            return;
        }
        this.setState({ error: '', loading: true });
        try {
            
            await updateprof(this.state.uname).then(() =>{
                message.success({
                    content: 'Name Changed',
                    onClick: () =>{
                    this.state.props.history.push('/')
                }})
                    this.setState({error: '', loading: false})
            });
        } catch (error) {
        
            this.setState({ error: error.message, loading: false });
        }
        this.setState({ editEnable: false })
    }
    async updatepropic(event) {
        event.preventDefault();
        this.setState({ error: '' });
        try {
            await updatephoto(this.state.upic);
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    render() {
        return (
            <DashboardContainer>
                <Head />
                {
                    this.state.loading ? <Loader /> :
                        <DashMainWrapper>
                            <div className='profile-view-container'>
                                {
                                    !this.state.editEnable &&
                                    <DashProfContainer>
                                        <div className='prof-img-div'>
                                            <img src="https://i.pinimg.com/originals/73/16/f5/7316f550de9ca0045e3d8d98a5bb5e44.png" />
                                        </div>
                                        <div className='prof-details-div'>
                                            <p className='prof-usename'>{auth().currentUser.displayName}</p>
                                            <p className='prof-email'>{auth().currentUser.email}</p>
                                            <HomeConnectButton 
                                            width='125px' height='32px' fontsize='14px'
                                             onClick={() => this.setState({ editEnable: true })}>Edit Profile</HomeConnectButton>
                                        </div>
                                    </DashProfContainer>
                                }
                                {
                                    this.state.editEnable &&
                                    <div className='edit-extend'>
                                        <DashProfContainer>
                                            <div className='prof-img-div'>
                                                <img src="https://i.pinimg.com/originals/73/16/f5/7316f550de9ca0045e3d8d98a5bb5e44.png" />
                                            </div>
                                            {!auth().currentUser.photoURL ?
                                                <div>
                                                    <label>
                                                        < div className='file-upload-label'>Change Picture</div>
                                                        <input id="upic" ref="upload" style={{ display: 'none' }} onChange={this.handleChange} accept="image/*" type="file" name="upic" value={this.state.upic}></input>
                                                    </label>
                                                </div>

                                                : <div className='prof-img-div'>
                                                    <img src={auth().currentUser.photoURL} />
                                                </div>
                                            }

                                        </DashProfContainer>
                                        <DashFormDiv>
                                            <label>Username :</label>
                                            <Input placeholder='enter your username' id="uname" onChange={this.handleChange} name="uname" 
                                            value={this.state.uname}
                                             />
                                            <label>Email Address :</label>
                                            <text>{auth().currentUser.email}</text>
                                            <HomeConnectButton width='125px' height='32px' 
                                            fontsize='14px' 
                                            style={{marginTop:'20px'}}
                                            onClick={this.updateprofile}>Save Profile</HomeConnectButton>
                                        </DashFormDiv>
                                    </div>
                                }
                            </div>
                        </DashMainWrapper>
                }
             
            </DashboardContainer >
        );
    }
};

